import api from '../api';

const financialCaseApi = {
  // Lấy tất cả financial cases với phân trang
  getAllFinancialCases: async (token, params = {}) => {
    try {
      // Tạo config cho request
      const requestConfig = {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          limit: params.limit || 10,
          page: params.page || 1,
          ...params // Merge tất cả params khác
        }
      };

      const response = await api.get('/financial-cases', requestConfig);
      return response.data;
    } catch (error) {
      console.error('🔍 [DEBUG] getAllFinancialCases error:', error);
      throw error;
    }
  },

  // Lấy financial case theo ID
  getFinancialCaseById: async (token, id) => {
    try {
      const response = await api.get(`/financial-cases/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Approve/Reject financial case
  approveRejectCase: async (token, id, action, note) => {
    try {
      const response = await api.post(`/financial-cases/${id}/approve-reject`, {
        action, // 'approve' hoặc 'reject'
        note
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy thống kê financial cases
  getStatistics: async (token, params = {}) => {
    try {
      const response = await api.get('/financial-cases/statistics/overview', {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy thống kê financial cases (alias)
  getFinancialStatistics: async (token, params = {}) => {
    try {
      const response = await api.get('/financial-cases/statistics/overview', {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Tạo financial case mới (accountant có thể tạo)
  createFinancialCase: async (token, financialData) => {
    try {
      const response = await api.post('/financial-cases', financialData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('🔍 [DEBUG] createFinancialCase error:', error);
      throw error;
    }
  },

  // Cập nhật financial case
  updateFinancialCase: async (token, id, financialData) => {
    try {
      const response = await api.put(`/financial-cases/${id}`, financialData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Xóa financial case
  deleteFinancialCase: async (token, id) => {
    try {
      const response = await api.delete(`/financial-cases/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default financialCaseApi; 